/**
 * ObjectHistoryPanel React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';
import connect from "react-redux/es/connect/connect";

// Material-UI
import {withStyles} from "@material-ui/core";

// Material-UI components
import CircularProgress from '@material-ui/core/CircularProgress';

// application components
import HistoryTable from "./HistoryTable";
import WarningPanel from "../base/WarningPanel";

// application
import {fetchObjectHistory} from "../../operations/history";


/**
 * ObjectHistoryPanel shows the changes of an object
 *
 * @author Jens Gruschel
 */
export class ObjectHistoryPanel extends React.Component {

    _isMounted = false;

    state = {
        waiting: false,
        disconnected: false,
        changes: []
    }

    componentDidMount() {
        this._isMounted = true;
        this.refresh();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        if (this.props.objectId !== prevProps.objectId || this.props.time !== prevProps.time) {
            this.refresh();
        }
    }

    refresh() {
        this.setState({
            waiting: true,
            disconnected: false,
            changes: []
        })
        this.fetchData();
    }

    async fetchData() {
        const objectId = this.props.objectId;
        try {
            const changes = await fetchObjectHistory(this.props.accessToken, this.props.objectId, this.props.types);
            if (this._isMounted && objectId === this.props.objectId) {
                this.setState({
                    waiting: false,
                    disconnected: false,
                    changes: changes
                });
                // otherwise this information is not important any more
                // (possibly meanwhile another query is running)
            }
        }
        catch (error) {
            if (this._isMounted && objectId === this.props.objectId) {
                this.setState({
                    waiting: false,
                    disconnected: true,
                    changes: []
                });
                // otherwise this information is not important any more
                // (possibly meanwhile another query is running)
            }
        }
    }

    render() {
        const { classes } = this.props;

        return <div className={classes.root}>
                {
                    this.state.waiting && <CircularProgress className={classes.progress} />
                }
                {
                    this.state.disconnected && <WarningPanel text="Verbindung zum Server unterbrochen!" />
                }
                {
                    this.state.changes.length > 0 && <HistoryTable changes={this.state.changes} onUndo={this.props.onUndo} />
                }
        </div>;
    }
}

const styles = theme => ({
    root: {
        width: "100%",
        marginTop: 20,
        marginBottom: 20
    },
    progress: {
        display: "block",
        margin: "16px auto"
    }
});

ObjectHistoryPanel.propTypes = {
    objectId: PropTypes.string.isRequired,
    time: PropTypes.string,
    onUndo: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        types: state.types,
        accessToken: state.authorization.accessToken
    };
}

export default connect(mapStateToProps)(withStyles(styles)(ObjectHistoryPanel));